var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_c('span',{staticClass:"ada-tooltip"},[_vm._v("captcha response")]),_c('div',{attrs:{"id":'captcha-div_' + _vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }